/*
{
  url: string -- 이동하려는 주소('/project/1') 또는 라우터 이름({name:'', params:{id:1}})
}
*/
export default [
  {
    url: {name: 'maps'},
    name: 'MAP',
    icon: 'MapIcon',
    activeCode: '',
    project_type: 'MAP',
  },
  // {
  //   url: {name: 'project-home', params:{proj_id: 1}},
  //   name: '총괄관리',
  //   icon: 'AlertTriangleIcon',
  //   activeCode: '',
  //   project_type: '총괄관리',
  // },
  {
    url: {name: 'project-home', params:{proj_id: 2}},
    name: '내부종사자 분야',
    icon: 'UsersIcon',
    activeCode: '',
    project_type: '내부종사자',
  },
  {
    url: {name: 'project-home', params:{proj_id: 3}},
    name: '도급·용역·위탁사업 분야',
    icon: 'UsersIcon',
    activeCode: '',
    project_type: '도급',
  },
  {
    url: {name: 'project-home', params:{proj_id: 4}},
    name: '발주사업 분야',
    icon: 'UsersIcon',
    activeCode: '',
    project_type: '발주',
  },
  {
    url: {name: 'project-home', params:{proj_id: 5}},
    name: '중대시민재해 분야',
    icon: 'ShieldIcon',
    activeCode: '',
    project_type: '중대시민재해',
  },
  {
    url: '/',
    name: '공지사항',
    activeCode: '',
    submenu: [
      {
        url: '/community/businessnews',
        name: '안전보건관리책임자 지시사항',
        icon: 'w-line',
        activeCode: ''
      },
      {
        url: '/community/healthinfo',
        name: '안전보건 주요 일정',
        icon: 'w-line',
        activeCode: ''
      },
      {
        url: '/community/unitbusinessnews',
        name: '구성원 요청사항',
        icon: 'w-line',
        activeCode: ''
      },
      {
        url: '/community/popup-notice',
        name: '공지사항(팝업관리)',
        icon: 'w-line',
        activeCode: 'content_community_popupnotice'
      },
      {
        url: '/community/qna',
        name: 'Q&A',
        icon: 'w-line',
        activeCode: ''
      }
    ]
  },
  {
    url: '/',
    name: '마이페이지',
    activeCode: '',
    submenu: [
      {
        url: '/mypage/workstatus',
        name: '업무현황',
        icon: 'w-line',
        activeCode: ''
      },
      {
        url: '/mypage/alert',
        name: '알림',
        icon: 'w-line',
        activeCode: ''
      },
      {
        url: '/',
        name: '설정',
        icon: 'w-line',
        activeCode: '',
        submenu: [
          {
            url: '/mypage/info-update',
            name: '개인정보변경',
            icon: 'w-line',
            activeCode: ''
          }
        ]
      }
    ]
  }
]
